import { FormEvent, useState } from 'react';
import { ArrowRight, BarChart3, Fingerprint, ShieldCheck } from 'lucide-react';
import { api } from './api';
import { User } from './App';

export function Login({ error, onLogin }: { error: string | null; onLogin: (user: User) => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [message, setMessage] = useState(error);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setMessage(null);
    try {
      const result = await api<{ user: User }>('/api/auth/login', {
        method: 'POST', body: JSON.stringify({ username, password, rememberMe }),
      });
      onLogin(result.user);
    } catch (caught) {
      setMessage(caught instanceof Error ? caught.message : 'Přihlášení se nepodařilo.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-story">
        <div className="brand-lockup"><span className="brand-cube">S</span><span>SHX OFFICE</span></div>
        <div className="story-copy">
          <span className="eyebrow light">Řízení firmy bez tabulkového chaosu</span>
          <h1>Všechna důležitá čísla.<br />Jeden spolehlivý systém.</h1>
          <p>Finance, docházka i marketing ve vlastním datovém modelu, s dohledatelnými změnami a živými zdroji.</p>
          <div className="login-benefits">
            <span><BarChart3 size={18} /> Interaktivní rozhodování</span>
            <span><ShieldCheck size={18} /> Audit a řízená oprávnění</span>
            <span><Fingerprint size={18} /> Jeden účet z Vendure</span>
          </div>
        </div>
        <div className="story-orbit orbit-one" /><div className="story-orbit orbit-two" />
      </section>
      <section className="login-form-wrap">
        <form className="login-card" onSubmit={submit}>
          <span className="eyebrow">Bezpečné přihlášení</span>
          <h2>Vítejte zpět</h2>
          <p className="muted">Použijte stejné přihlašovací údaje jako do administrace Vendure.</p>
          <label>Uživatelské jméno<input autoComplete="username" value={username} onChange={event => setUsername(event.target.value)} required autoFocus /></label>
          <label>Heslo<input type="password" autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} required /></label>
          <label className="check-row"><input type="checkbox" checked={rememberMe} onChange={event => setRememberMe(event.target.checked)} /><span>Zůstat přihlášený 7 dní</span></label>
          {message && <div className="form-error">{message}</div>}
          <button className="button primary wide" disabled={busy}>{busy ? 'Ověřuji…' : <>Přihlásit se <ArrowRight size={18} /></>}</button>
          <p className="security-note"><ShieldCheck size={15} /> Heslo ověřuje Vendure a SHX Office ho nikde neukládá.</p>
        </form>
      </section>
    </main>
  );
}
